import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import css from './SpaceGroups.module.css';
import {
  AspectRatioWrapper,
  Button,
  FieldRadioButton,
  FieldSelect,
  FieldTextInput,
  Form,
  H4,
} from '../../../../components';
import { accessTypeData } from '../../../../util/circleHelper';
import { FormattedMessage } from '../../../../util/reactIntl';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { UploadImage } from '../../../../util/cloudinary';
import { required } from '../../../../util/validators';

export const FieldAddImage = props => {
  const {
    formApi,
    onImageUploadHandler,
    aspectWidth = 1,
    aspectHeight = 1,
    imgType,
    ...rest
  } = props;
  return (
    <Field form={null} {...rest}>
      {fieldprops => {
        const { accept, input, label, disabled: fieldDisabled } = fieldprops;
        const { name, type } = input;
        const onChange = e => {
          const file = e.target.files[0];
          formApi.change(`addImage`, file);
          formApi.blur(`addImage`);
          onImageUploadHandler(file, imgType);
        };
        const inputProps = { accept, id: name, name, onChange, type };
        return (
          <div className={css.addImageWrapper}>
            <AspectRatioWrapper width={aspectWidth} height={aspectHeight}>
              {fieldDisabled ? null : <input {...inputProps} className={css.addImageInput} />}
              <label htmlFor={name} className={css.addImage}>
                <ProfileIconCard type="upload" />
                {label}
              </label>
            </AspectRatioWrapper>
          </div>
        );
      }}
    </Field>
  );
};

const ACCEPT_IMAGES = 'image/*';
const RequestSpaceForm = props => {
  const [accessType, setAccessType] = useState('');
  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const {
          form,
          handleSubmit,
          onChange,
          invalid,
          pristine,
          submitting,
          spaceGroups,
          requestNewSpace,
          values,
          loading,
          handleCreateNewSpace,
        } = fieldRenderProps;

        const onImageUploadHandler = (file, type) => {
          const { listingImageConfig, onImageUpload } = props;
          if (file) {
            UploadImage({ id: `${file.name}_${Date.now()}`, file, folder: 'space-groups' }).then(cloudnaryResponse => {
              console.log(cloudnaryResponse, 'cloudnaryResponse');
              const { secure_url } = cloudnaryResponse;
              if (type === 'desktopBanner') {
                form.change('desktopBanner', secure_url);
              } else {
                form.change('mobileBanner', secure_url);
              }
              return cloudnaryResponse;
            });
          }
        };

        return (
          <Form onSubmit={values => {}}>
            <div className={css.requestModal}>
              <H4 className={css.requestHeading}>
                <FormattedMessage id="CircleFeedPage.requestGroupButton" />
              </H4>
              <FieldTextInput
                className={css.inputBox}
                id={'spaceTitle'}
                name={'spaceTitle'}
                type="text"
                placeholder="Type your question here"
                label={'Group name'}
                validate={required('SpaceTitle is required')}
              />
              <FieldSelect
                id={'spaceGroup'}
                name={'spaceGroup'}
                className={css.inputBox}
                label={'Category'}
                validate={required('SpaceGroup is required')}
              >
                <option key={''} value={''}>
                  select
                </option>
                {spaceGroups
                  ?.filter(item => !item.is_private)
                  ?.map(item => (
                    <option key={item.space_group_id} value={item.space_group_name}>
                      {item.space_group_name}
                    </option>
                  ))}
              </FieldSelect>

              <FieldTextInput
                className={css.inputDescriptionBox}
                id={'spaceDescription'}
                name={'spaceDescription'}
                type="textarea"
                placeholder="Short description about this group"
                label={'Let the admin know your vision for this group'}
              />
              {/* <div className={css.radioInput}>
              {accessTypeData.map((item, index) => (
                <div className={css.userTypeCheck} key={item.label + '-' + index}>
                  <FieldRadioButton
                    id={`${item.label}-accessType`}
                    name="accessType"
                    label={item.label}
                    value={item.value}
                    validate={required("AccessType is required")}
                  />
                </div>
              ))}
            </div> */}
              <div className={css.radioInput}>
                {accessTypeData.map((item, index) => (
                  <div
                    className={`${css.userTypeCheck} ${
                      accessType === item.value ? css.selected : ''
                    }`}
                    key={item.label + '-' + index}
                    onClick={() => setAccessType(item.value)}
                    tabIndex={0}
                    role="button"
                    aria-pressed={accessType === item.value}
                    style={{ outline: 'none' }}
                  >
                    <span
                      className={css.customRadio}
                      style={{
                        width: 20,
                        height: 20,
                        display: 'inline-block',
                        marginRight: 10,
                        backgroundImage: `url(${
                          accessType === item.value
                            ? require('../../../../assets/images/checked.png')
                            : require('../../../../assets/images/defaultCheck.png')
                        })`,
                        backgroundSize: 'cover',
                      }}
                    />
                    <span>{item.label}</span>
                  </div>
                ))}
              </div>
              <div className={css.bannerHeading}>Banner</div>
              <div className={css.desktopGalleryImage}>
                <div className={css.imageSize}>Desktop | 1382 x 244</div>
                <div className={css.upaloderDesktop}>
                  <FieldAddImage
                    id="desktopBanner"
                    name="desktopBanner"
                    accept={ACCEPT_IMAGES}
                    label={
                      <span className={css.chooseImageText}>
                        {values.desktopBanner ? (
                          <img
                            src={values.desktopBanner}
                            className={css.previewImage}
                            width={'100px'}
                            height={'100px'}
                          />
                        ) : (
                          <span className={css.chooseImage}>Upload Desktop Banner</span>
                        )}
                      </span>
                    }
                    type="file"
                    formApi={form}
                    onImageUploadHandler={onImageUploadHandler}
                    aspectWidth={1}
                    aspectHeight={1}
                    imgType={'desktopBanner'}
                  />
                </div>
              </div>
              <div className={css.mobileImageGallery}>
                <div className={css.imageSize}>Mobile | 393 x 221</div>
                <div className={css.mobileRow}>
                  <div className={css.upaloderMobile}>
                    <FieldAddImage
                      id="mobileBanner"
                      name="mobileBanner"
                      accept={ACCEPT_IMAGES}
                      label={
                        <span className={css.chooseImageText}>
                          {values.mobileBanner ? (
                            <img
                              src={values.mobileBanner}
                              className={css.previewImage}
                              width={'100px'}
                              height={'100px'}
                            />
                          ) : (
                            <span className={css.chooseImage}>Upload Mobile Banner</span>
                          )}
                        </span>
                      }
                      type="file"
                      formApi={form}
                      onImageUploadHandler={onImageUploadHandler}
                      aspectWidth={1}
                      aspectHeight={1}
                      imgType={'mobileBanner'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Button
              className={css.groupButton}
              type="button"
              disabled={invalid}
              inProgress={loading}
              onClick={e => {
                e.preventDefault();
                handleCreateNewSpace({ ...values, accessType }, form);
              }}
            >
              <FormattedMessage id="CircleFeedPage.requestGroupButton" />
            </Button>
          </Form>
        );
      }}
    />
  );
};

export default RequestSpaceForm;
